import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { OverlayContext } from "../../../context/OverlayContext";
import { ToastContext } from "../../../context/ToastContext";
import { NavigationContext } from "../../../context/NavigationContext";
import { Table, Typography, Button, Form, List, Tag, Tooltip, Input } from "antd";
import { ArrowLeftOutlined, StopOutlined } from "@ant-design/icons";
import OffersService from "../../../services/crud/OfferService";
import Offer from "../../../models/Offer";
import { OfferFormGenericForm } from "../../../components/forms/OfferForm";
import DescriptionDataList from "../../../components/DescriptionDataList";

const OfferView = () => {
  const { loading, loadMessage } = useContext(ToastContext);
  const { openModal, closeModal } = useContext(OverlayContext);
  const [form] = Form.useForm<Offer>();
  const { id } = useParams();
  const [offer, setOffer] = useState<Offer>({} as Offer);

  useEffect(() => {
    if (id) {
      form.resetFields();
      loadMessage("Loading Offer item...", () =>
        OffersService.getOffer(id).then((data) => {
          setOffer(data);
        })
      );
    }
  }, [id, form]);

  const openEditModal = () => {
    form.resetFields();
    openModal({
      title: "Edit Offer",
      content: <OfferFormGenericForm form={form} id={id} />,
      onOk: () => {
        form.validateFields().then(async (values) => {
          loadMessage("Updating Offer...", async () => {
            OffersService.editOffer(id, values);
            closeModal();
          });
        });
      },
    });
  };

  return (
    <div>
      <Typography.Title level={2}>Offer</Typography.Title>
      <DescriptionDataList data={offer} />
      <Button type="primary" onClick={openEditModal}>
        Edit Offer
      </Button>
    </div>
  );
};

export default OfferView;

